var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LinearProgress, Divider, Grid, Typography } from '@mui/material';
import { useRequest } from '../../hooks/requestHook';
import { useRoaster } from '../../hooks/useRoaster';
import PageLayout from '../atoms/PageLayout';
import { useParams } from 'react-router-dom';
import { offerList as apiOfferList } from '../../api';
import NewPreOrderRequestForm from './NewPreOrderRequestForm';
import SelectField from '../atoms/SelectFieldNew';
import { useLocation } from 'react-router-dom';
var PreOrderRequestNewPage = function (_a) {
    var isRoaster = _a.isRoaster;
    var t = useTranslation().t;
    var id = useParams().id;
    var search = useLocation().search;
    var apiOfferListGetAll = useRequest(apiOfferList.getAll);
    var roaster = useRoaster(id).roaster;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState([]), orderedOfferLists = _c[0], setOrderedOfferLists = _c[1];
    var _d = React.useState(), selectedOfferList = _d[0], setSelectedOfferList = _d[1];
    var query = React.useMemo(function () { return new URLSearchParams(search); }, [search]);
    var findOfferList = React.useCallback(function (selectedOfferListId) {
        return orderedOfferLists.find(function (_a) {
            var id = _a.id;
            return id === selectedOfferListId;
        });
    }, [orderedOfferLists]);
    React.useEffect(function () {
        if (!roaster || query.get('offerListId') === null)
            return;
        setSelectedOfferList(findOfferList(query.get('offerListId')));
    }, [query, roaster, findOfferList]);
    React.useEffect(function () {
        if (!roaster)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, apiOfferListGetAll({
                                q: { ordered_by_roaster: [roaster.id] },
                            })];
                    case 1:
                        response = _a.sent();
                        setLoading(false);
                        if (canceled || !response)
                            return [2 /*return*/];
                        setOrderedOfferLists(response.data);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [apiOfferListGetAll, roaster]);
    var offerListItems = React.useMemo(function () {
        if (orderedOfferLists.length === 0)
            return;
        return orderedOfferLists.map(function (offerList) { return ({
            text: offerList.name,
            value: offerList.id,
        }); });
    }, [orderedOfferLists]);
    if (!roaster || loading)
        return React.createElement(LinearProgress, null);
    if (orderedOfferLists.length === 0)
        return React.createElement(Typography, null, t('messages.orderedOfferNotExist'));
    return (React.createElement(PageLayout, { title: t('pages.preOrderRequest.new'), backLink: true },
        React.createElement(Divider, null),
        React.createElement(Grid, { container: true, spacing: 3, style: { marginTop: 5 } },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(SelectField, { items: offerListItems || [], onChange: function (offerListId) {
                        return setSelectedOfferList(findOfferList(offerListId));
                    }, value: (selectedOfferList === null || selectedOfferList === void 0 ? void 0 : selectedOfferList.id) || '', label: t('params.offerList.name'), fullWidth: true }))),
        selectedOfferList && (React.createElement(NewPreOrderRequestForm, { roaster: roaster, offerList: selectedOfferList, isRoaster: isRoaster }))));
};
export default PreOrderRequestNewPage;
